export default __webpack_public_path__ + "static/media/day1.3d84fa39.png";